export const REGISTRATION_FORM_URL = 'https://forms.gle/bA4MHcfB3B36n1E38';
export const WHATSAPP_CHAT_URL = 'https://chat.whatsapp.com/GsFo0KtYTMqHyMpJJZu7wo';
export const CONTACT_EMAIL = 'asociacion@unavozdiferente.com';
